var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-empty-record"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('p',[_vm._v("No records")])])}]

export { render, staticRenderFns }